import { DocumentFormValues } from './DocumentForm'

/** Bezpečný převod na číslo: cokoli nekonečného nebo NaN (např. "2w") je 0. Bere i desetinnou čárku. */
export const toNumber = (value: unknown): number => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0
  if (typeof value === 'string') {
    const n = Number(value.replace(/\s/g, '').replace(',', '.'))
    return Number.isFinite(n) ? n : 0
  }
  return 0
}

const lineBase = (item: DocumentFormValues['items'][number]) => toNumber(item.amount) * toNumber(item.unitPrice)

const lineRate = (item: DocumentFormValues['items'][number]) => toNumber(item?.taxRate) / 100

export const calculateTotalWithoutTaxes = (
  items: DocumentFormValues['items'],
) => items.reduce((acc, item) => acc + lineBase(item), 0)

export const calculateTax = (items: DocumentFormValues['items']) =>
  items.reduce((acc, item) => acc + lineBase(item) * lineRate(item), 0)

export const calculateTotal = (items: DocumentFormValues['items']) =>
  items.reduce((acc, item) => acc + lineBase(item) * (1 + lineRate(item)), 0)

export const calculateTotals = (items: DocumentFormValues['items']) => {
  const totalWithoutTaxes = calculateTotalWithoutTaxes(items)
  const tax = calculateTax(items)
  const total = calculateTotal(items)

  return {
    totalWithoutTaxes,
    tax,
    total,
  }
}
